/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function Android() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'Android',
				config: {
					ruleType: "os",
					args: {
						os: ["android"],
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			Android
			operating
			systems.
		</p>
	</>;
}
